const prefix = 'PLAZA_TOPOLOGY_';

export const ACTION_TYPES = {
  INIT_EDITOR: `${prefix}INIT_EDITOR`,
  RESET_TO_INITIAL_STATE: `${prefix}RESET_TO_INITIAL_STATE`,
  NEW_PLAZA: `${prefix}NEW_PLAZA`,
  TOGGLE_FETCHING: `${prefix}TOGGLE_FETCHING`,
  SET_PLAZA_ID: `${prefix}SET_PLAZA_ID`,
  UPDATE_DYNAMIC_DATA: `${prefix}UPDATE_DYNAMIC_DATA`,
  SET_NODE_LIST: `${prefix}SET_NODE_LIST`,
  SET_EXTERNAL_SOURCES: `${prefix}SET_EXTERNAL_SOURCES`,
  SET_REGULAR_AND_EXTERNAL_SOURCES: `${prefix}SET_REGULAR_AND_EXTERNAL_SOURCES`,
  SET_EDITABLE_NODE_ID: `${prefix}SET_EDITABLE_NODE_ID`,
  UPDATE_TOPOLOGY: `${prefix}UPDATE_TOPOLOGY`,
  UPDATE_NODES_LIST: `${prefix}UPDATE_NODES_LIST`,
  CREATE_NODE: `${prefix}CREATE_NODE`,
  UPDATE_NODE: `${prefix}UPDATE_NODE`,
  REMOVE_NODE: `${prefix}REMOVE_NODE`,
  DELETE_NODE: `${prefix}DELETE_NODE`,
  CREATE_RESOURCE_NODE: `${prefix}CREATE_RESOURCE_NODE`,
  UPDATE_RESOURCE_NODE: `${prefix}UPDATE_RESOURCE_NODE`,
  DELETE_RESOURCE_NODE: `${prefix}DELETE_RESOURCE_NODE`,
  ADD_TO_REQUEST_QUEUE: `${prefix}ADD_TO_REQUEST_QUEUE`,
  REMOVE_FROM_REQUEST_QUEUE: `${prefix}REMOVE_FROM_REQUEST_QUEUE`,
  SET_PLAZA_SETTINGS: `${prefix}SET_PLAZA_SETTINGS`,
  SET_NODE_ERRORS: `${prefix}SET_NODE_ERRORS`,
  SET_PLAZA_ERRORS: `${prefix}SET_PLAZA_ERRORS`,
  SET_PLAZA_PATCHING: `${prefix}SET_PLAZA_PATCHING`,
  SET_LOCK_INTERVAL: `${prefix}SET_LOCK_INTERVAL`,
  CLEAR_LOCK_INTERVAL: `${prefix}CLEAR_LOCK_INTERVAL`,
  SET_LOCK_TIMEOUT: `${prefix}SET_LOCK_TIMEOUT`,
  CLEAR_LOCK_TIMEOUT: `${prefix}CLEAR_LOCK_TIMEOUT`,
  SET_CONFIRMATION_TIMEOUT: `${prefix}SET_CONFIRMATION_TIMEOUT`,
  CLEAR_CONFIRMATION_TIMEOUT: `${prefix}CLEAR_CONFIRMATION_TIMEOUT`,
  SET_EDITOR_EDITABLE: `${prefix}SET_EDITOR_EDITABLE`,
  UPDATE_LOCK_STATUS: `${prefix}UPDATE_LOCK_STATUS`,
  SET_UPDATED_STATUS: `${prefix}SET_UPDATED_STATUS`,
  SET_CHARGERS_BY_ADDRESS: `${prefix}SET_CHARGERS_BY_ADDRESS`,
  RESET_CHARGERS_BY_ADDRESS: `${prefix}RESET_CHARGERS_BY_ADDRESS`,
  SET_NODE_TOPOLOGY_ERRORS: `${prefix}SET_NODE_TOPOLOGY_ERRORS`,
  // no actions
  SET_CHARGERS_WITHOUT_PLAZA: `${prefix}SET_CHARGERS_WITHOUT_PLAZA`,
  SET_PLAZA_STATUS: `${prefix}SET_PLAZA_STATUS`,
};
